import axios from 'axios';
import LoginService from '../acesso/login.service';

const API_URL = process.env.VUE_APP_BASE_URL + '/api/tributario/servicoNacional/';

class ServicoNacionalService {
    constructor() {
        this.idCliente = null;
        LoginService.currentUser.subscribe(data => {
            this.headers = {
                'Content-Type': 'application/json',
                'authorization': 'Bearer ' + (data ? data.token : '')
            };
        });
    }

    findAllByContribuinteFiltro(idCliente, idContribuinte, filtro, notaAvulsa) {
        return axios.get(API_URL + 'filterContribuinte?idCliente=' + idCliente + '&idContribuinte=' + idContribuinte + '&filtro=' + filtro + '&notaAvulsa=' + notaAvulsa, { headers: this.headers }).then(response => (this.data = response.data.elements));
    }
    findAllByServicoFiltro(idServico, filtro) {
        return axios.get(API_URL + 'filter?idServico=' + idServico + '&filtro=' + filtro, { headers: this.headers }).then(response => (this.data = response.data.elements));
    }

    findAllNBSByServicoNacionalFiltro(idServicoNacional, filtro) {
        return axios.get(API_URL + 'filterNbs?idServicoNacional=' + idServicoNacional + '&filtro=' + filtro, { headers: this.headers }).then(response => (this.data = response.data.elements));
    }

    findAllIndopByClienteFiltro(idCliente, filtro) {
        return axios.get(API_URL + 'filterIndop?idCliente=' + idCliente + '&filtro=' + filtro, { headers: this.headers }).then(response => (this.data = response.data.elements));
    }

    findAllClasstribByClienteFiltro(idCliente, filtro) {
        return axios.get(API_URL + 'filterClasstrib?idCliente=' + idCliente + '&filtro=' + filtro, { headers: this.headers }).then(response => (this.data = response.data.elements));
    }

    findAllIndopByServicoNbsFiltro(idCliente, idNbs, filtro) {
        return axios.get(API_URL + 'filterIndopNbs?idCliente=' + idCliente + '&idNbs=' + idNbs + '&filtro=' + filtro, { headers: this.headers }).then(response => (this.data = response.data.elements));
    }

    findAllClasstribByIndopFiltro(idCliente, idIndop, filtro) {
        return axios.get(API_URL + 'filterClasstribIndop?idCliente=' + idCliente + '&idIndop=' + idIndop + '&filtro=' + filtro, { headers: this.headers }).then(response => (this.data = response.data.elements));
    }

}

export default new ServicoNacionalService();